export default __webpack_public_path__ + "open-folder.png";